const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  updating: false,
  error: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'LISTING_FIELDS_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'LISTING_FIELDS_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case 'LISTING_FIELDS_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }

    default:
      return state
  }
}
